<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDati > 0"
      color="blue lighten-4"
      item-key="idx"
      :headers="headers"
      :items="datiMostrati"
      :options.sync="options"
      :server-items-length="totaleDati"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Importazione dati da file Excel</v-toolbar-title>
      </v-toolbar>
      <parametri
        :loading="isImportaDati"
        :loading-categorie="isAggiornaCategorie"
        @changeModello="onChangeModello"
        @importa="importaDati"
        @onLoaded="onLoaded"
        @cambiaVista="cambiaVista"
        />
    </template>
    <template v-slot:no-data>
      Carica un file Excel
    </template>
    </v-data-table>
    <v-dialog
      v-model="isImportaDati"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Importazione dati in corso
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import Parametri from './parametri'
  // import categorie from '@/services/categorieService'
  import { creaElementi, creaElementiCategoria } from './tipi/dati.js'
  
  export default {
    components: {
      Parametri
    },
    mixins: [verificaLicenza],
    data () {
      return {
        selected: [],
        loading: true,
        options: {},
        expanded: [],
        singleExpand: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        mostraRaw: false,
        datiRaw: [],
        datiModello: [],
        totaleDati: 0,
        intestazioniRaw: [],
        intestazioniModello: [],
        isImportaDati: false,
        modelloItem: null,
        isAggiornaCategorie: false
      }
    },
    async mounted() {
      await this.verificaModuliLocali()
    },
    computed: {
      formTitle () {
        return 'Importazione dati da file Excel'
      },
      datiMostrati() {
        let dati = this.mostraRaw ? this.datiRaw : this.datiModello
        dati = dati.map((x, idx) => { return { idx, ...x } })
        const opz = this.options
        return _.take(_.drop(dati, (opz.page - 1) * opz.itemsPerPage), opz.itemsPerPage)
         
      },
      headers() {
        return this.mostraRaw ? this.creaHeaders(this.intestazioniRaw) : this.creaHeaders(this.intestazioniModello)
      }
    },
    watch: {
      options: {
        async handler () {
          this.loading = false
        },
        deep: true
      }
    },
    methods: {
      backClick() {
        this.$emit('back')
      },
      onChangeModello(modello) {
        this.modelloItem = modello
      },
      onLoaded(dati) {
        if (!dati) {
          this.datiRaw = []
          this.datiModello = []
          this.totaleDati = 0
          this.intestazioniModello = []
          this.intestazioniRaw = []
          return
        }
        this.datiRaw = dati.datiRaw
        this.datiModello = dati.datiModello
        this.totaleDati = dati.datiRaw.length
        this.intestazioniModello = dati.intestazioniModello
        this.intestazioniRaw = dati.intestazioniRaw
      },
      cambiaVista(value) {
        this.mostraRaw = value
      },
      creaHeaders(colonne, dati) {
        const hd = []
        for (let c of colonne) {
          const hh = { text: c.value, value: c.key }
          hd.push(hh)
        }
        return hd
      },
      async importaDati(forzaAggiornamento) {
        if (this.totaleDati > 0 && this.modelloItem) {
          this.isImportaDati = true
          const dati = this.selected.length > 0 ? this.selected : this.datiModello
          await creaElementiCategoria(dati, this.modelloItem.datiDefault, this.modelloItem.valoriDefault, null, forzaAggiornamento)
          this.annullaSelezione()
          this.isImportaDati = false
        }
      },
      clickRow(item, options) {
      },
      dblclickRow(event, options) {
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
</style>
